import React from 'react';
import ServerMaintenanceImage from '../assets/images/ServerMaintenance.png';

const MaintenanceScreen = ({ onRetry }) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md w-full space-y-8">
                <div className="text-center">
                    {/* Maintenance Image */}
                    <div className="mx-auto flex items-center justify-center">
                        <img
                            src={ServerMaintenanceImage}
                            alt="Server Maintenance"
                            className="h-32 w-32 object-contain"
                        />
                    </div>

                    {/* Title */}
                    <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                        Website Under Maintenance
                    </h2>

                    {/* Message */}
                    <p className="mt-2 text-sm text-gray-600">
                        We're currently performing scheduled maintenance to improve your experience.
                    </p>

                    {/* Additional Info */}
                    <p className="mt-4 text-xs text-gray-500">
                        We apologize for any inconvenience. You can expect some service disruptions during this time.
                        Our team is working to restore full service as quickly as possible.
                    </p>

                    {/* Retry Button */}
                    {onRetry && (
                        <div className="mt-8">
                            <button
                                onClick={onRetry}
                                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150 ease-in-out"
                            >
                                <svg
                                    className="h-5 w-5 mr-2"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                    />
                                </svg>
                                Try Again
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MaintenanceScreen; 